import { cn } from '@/shared/lib/cn';
import type { AgendaPill } from './agendaCardModel';

const PILL: Record<AgendaPill['tone'], string> = {
  amber: 'bg-amber-tint text-ink',
  red: 'bg-sealwax-tint text-sealwax',
};

/** Nächte als Segmente in Kanalfarbe; im Haus sind die verbrachten Nächte voll, der Rest blass. */
export function NightSegments({
  nights,
  done,
  tone,
  cancelled,
}: {
  nights: number;
  done: number | null;
  tone: string;
  cancelled: boolean;
}) {
  return (
    <span aria-hidden className="flex max-w-[240px] gap-[3px]">
      {Array.from({ length: Math.min(nights, 14) }, (_, index) => (
        <span
          key={index}
          className={cn(
            'h-2 flex-1 rounded-[4px]',
            tone,
            (cancelled || (done !== null && index >= done)) && 'opacity-30',
          )}
        />
      ))}
    </span>
  );
}

export function Facts({
  reference,
  people,
  pills,
}: {
  reference: string;
  people: string;
  pills: AgendaPill[];
}) {
  return (
    <span className="text-ink-soft flex flex-wrap items-center gap-1.5 text-xs">
      <span className="font-mono">{reference}</span>
      <span>· {people}</span>
      {pills.map((pill) => (
        <span
          key={pill.label}
          className={cn(
            'rounded-pill inline-flex h-[22px] items-center px-2 text-[11px] font-bold',
            PILL[pill.tone],
          )}
        >
          {pill.label}
        </span>
      ))}
    </span>
  );
}

export function ChannelMark({ letter, className }: { letter: string; className: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-6 flex-none items-center justify-center rounded-[7px] text-[10px] font-extrabold',
        className,
      )}
    >
      {letter}
    </span>
  );
}
